import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";

const GET_ROLES = gql`
  query getRoles {
    account {
      id
      roles {
        id
        name
        defaultPayRate
        defaultChargeRate
        internalId
        description
        isOvertimeRate
        defaultOvertimePayRate
        defaultOvertimeChargeRate
        defaultOvertimeHoursLimit
        isOverstayRate
        defaultOverstayPayRate
        defaultOverstayChargeRate
        defaultOverstayHoursLimit
      }
    }
  }
`;

export const useRoles = () => {
  const { data, loading, error, refetch } = useQuery(GET_ROLES, {
    fetchPolicy: "cache-and-network",
    onError: error => {
      throw error;
    }
  });

  const roles = data?.account?.roles || [];
  const accountId = data?.account.id;

  return {
    accountId,
    roles,
    loading,
    error,
    refetch
  };
};
